// removed by extract-text-webpack-plugin
module.exports = {"status-date":"StatusDate-module__status-date___3sIoJ","icon-base":"StatusDate-module__icon-base___3kn7x","icon":"StatusDate-module__icon___3L-45","date-base":"StatusDate-module__date-base___10a5x","mobile":"StatusDate-module__mobile___o9HTq"};


//////////////////
// WEBPACK FOOTER
// ./src/js/widgets/Status/StatusDate/StatusDate.module.scss
// module id = 260
// module chunks = 0 1